<template lang="pug">
  v-container(fluid)
    h1 Citizen Action
</template>

<script>
export default {};
</script>

<style lang="stylus" scoped></style>
